import React from 'react'
import logo from '../../Assets/logo 5.svg'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='footer-main'>
      <div className="container-main">
        <div className="footer-space">
            <div className="row">
              <div className="col-lg-12">
                <div className="footer-newsletter">
                  <div className="footer-half">
                    <h3 className='newsletter-text mb-0'>Subscribe Our Newsletter !</h3>
                    <p className='mb-0 newsletter-subtext'>Get the latest updates and important announcements delivered straight to your inbox. Subscribe now</p>
                  </div>
                  <div className="footer-half flx">
                    <form>
                      <div className="form-group">
                        <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter Email Address"/>
                      </div>
                      <button className="btn text-white submit-btn-news">Submit</button>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="footer-box">
                    <img src={logo} className="footer-logo" alt="" />
                    <p className="footer-sub-text">Q-Garden is the scriptural abode for women that is driven by ‘ women empowerment through education’ maxim.</p>
                    <h4 className="mb-0 footer-heading-sub-mains">Follow Us on</h4>
                    <div className="social-media-icons">
                      <i class="ri-instagram-line"></i>
                      <i class="ri-whatsapp-line"></i>
                      <i class="ri-facebook-circle-line"></i>
                      <i class="ri-twitter-x-line"></i>
                    </div>


                </div>
              </div>
              <div className="col-lg-3">
                <div className="footer-box">
                  <h4 className="mb-0 footer-heading-sub-main">Quick  Links</h4>
                  <ul className="mb-0">
                    <li><Link to="/">About us</Link></li>
                    <li><Link to="/">Articles</Link></li>
                    <li><Link to="/">Programes</Link></li>
                    <li><Link to="/">Admissions</Link></li>
                    <li><Link to="/">Exams Results</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="footer-box">
                  <h4 className="mb-0 footer-heading-sub-main">Contact</h4>
                  <ul className="mb-0">
                    <li><Link to="/">Contact  us</Link></li>
                    <li><Link to="/">Faq</Link></li>
                    <li><Link to="/">Programes</Link></li>
                    <li><Link to="/">Parent Community</Link></li>
                    <li><Link to="/">Help Center</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="footer-box">
                  <h4 className="mb-0 footer-heading-sub-main">School Hours</h4>
                  <ul className="mb-0">
                    <li><Link to="/">8 AM - 5 PM , Monday - Saturday</Link></li>
                    <li><Link to="/">Q-Garden , Kuttiadi (P.O.), Kuttiadi, Kozhikkode - 673 508</Link></li>
                    <li><Link to="/">Info@qgarden.in </Link></li>
                    <li><Link to="/">+91 82816 33786 </Link></li>
                    <li><Link to="/">+91 87144 05888</Link></li>
                  </ul>

                </div>
              </div>
              <div className="col-lg-12">
                <div className="copyy">
                  <p className="copy-text">© QGarden 2025 All rights reserved</p>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Footer